module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16.232 32C7.282 32 0 24.718 0 15.768 0 8.372 4.988 1.916 12.13.066a2.032 2.032 0 0 1 2.472 2.492 11.811 11.811 0 0 0-.398 3.064c0 6.714 5.46 12.176 12.176 12.176 1.048 0 2.08-.134 3.064-.396.702-.19 1.444.01 1.954.518.512.508.716 1.25.536 1.95C30.084 27.01 23.626 32 16.232 32z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/moon-1.js
// module id = 1287
// module chunks = 14